import { ThemeColorPalette, ThemeFontsCssPropertyName, HighContrastColors, FluentV9ColorTokens } from '@fluidx/component-ux';
// https://github.com/import-js/eslint-plugin-import/issues/1532
//eslint-disable-next-line import/no-deprecated
import { HighContrastSelector, IsFocusVisibleClassName, getFocusStyle } from '@fluentui/react';
const defaultButtonRadius = '4px';
const defaultBorderRadius = '12px';
const defaultFontFamily = `Segoe UI, sans-serif`;
/***
 * Helper function for retrieving the default contextual menu style
 */ function getSensitivityContextualMenuDefaultStyle(theme, customTokens) {
    return {
        contextualMenu: {
            root: {
                backgroundColor: customTokens?.pickerBackground || theme?.palette.white || ThemeColorPalette.Neutral.white,
                ['.is-expanded']: {
                    backgroundColor: customTokens?.pickerBackgroundHover || theme?.palette.neutralLighter || ThemeColorPalette.Neutral.neutralLighter,
                    color: customTokens?.pickerForegroundHover || theme?.palette.neutralPrimary || ThemeColorPalette.Neutral.neutralPrimary,
                    selectors: {
                        [HighContrastSelector]: {
                            color: HighContrastColors.SelectedText,
                            backgroundColor: HighContrastColors.SelectedBackground
                        },
                        i: {
                            color: customTokens?.pickerIconHover || theme?.palette.neutralSecondary || ThemeColorPalette.Neutral.neutralSecondary
                        }
                    }
                }
            },
            container: {
                overflow: 'hidden'
            },
            subComponentStyles: {
                menuItem: {
                    root: {
                        height: '32px',
                        lineHeight: '32px',
                        fontSize: customTokens?.pickerFontSize || `var(${ThemeFontsCssPropertyName.FontSizeMenu}, inherit)`,
                        color: customTokens?.pickerForeground || theme?.palette.neutralPrimary || ThemeColorPalette.Neutral.neutralPrimary,
                        fill: customTokens?.pickerIcon || theme?.palette.neutralSecondary || ThemeColorPalette.Neutral.neutralSecondary,
                        i: {
                            fontSize: customTokens?.pickerIconSize,
                            color: customTokens?.pickerIcon || theme?.palette.neutralSecondary || ThemeColorPalette.Neutral.neutralSecondary,
                            [HighContrastSelector]: {
                                color: HighContrastColors.ButtonText
                            }
                        },
                        [HighContrastSelector]: {
                            forcedColorAdjust: 'none',
                            color: HighContrastColors.ButtonText,
                            backgroundColor: HighContrastColors.ButtonBackground
                        },
                        [':hover']: {
                            backgroundColor: customTokens?.pickerBackgroundHover || theme?.palette.neutralLighter || ThemeColorPalette.Neutral.neutralLighter,
                            color: customTokens?.pickerForegroundHover || theme?.palette.neutralPrimary || ThemeColorPalette.Neutral.neutralPrimary,
                            fill: customTokens?.pickerIconHover || theme?.palette.neutralSecondary || ThemeColorPalette.Neutral.neutralSecondary,
                            [HighContrastSelector]: {
                                forcedColorAdjust: 'none',
                                color: HighContrastColors.SelectedText,
                                backgroundColor: HighContrastColors.SelectedBackground
                            },
                            i: {
                                color: customTokens?.pickerIconHover || theme?.palette.neutralSecondary || ThemeColorPalette.Neutral.neutralSecondary,
                                [HighContrastSelector]: {
                                    color: HighContrastColors.SelectedText
                                }
                            }
                        },
                        [':active']: {
                            backgroundColor: customTokens?.pickerBackgroundPressed || theme?.palette.neutralLight || ThemeColorPalette.Neutral.neutralLight,
                            color: customTokens?.pickerForegroundPressed || theme?.palette.neutralPrimary || ThemeColorPalette.Neutral.neutralPrimary,
                            fill: customTokens?.pickerIconPressed || theme?.palette.neutralSecondary || ThemeColorPalette.Neutral.neutralSecondary,
                            [HighContrastSelector]: {
                                forcedColorAdjust: 'none',
                                color: HighContrastColors.SelectedText,
                                backgroundColor: HighContrastColors.SelectedBackground,
                                fill: HighContrastColors.SelectedText
                            },
                            i: {
                                color: customTokens?.pickerIconPressed || theme?.palette.neutralSecondary || ThemeColorPalette.Neutral.neutralSecondary,
                                [HighContrastSelector]: {
                                    color: HighContrastColors.SelectedText
                                }
                            }
                        },
                        ['::after']: {
                            outlineColor: `${customTokens?.focusBorder || theme?.palette.neutralPrimary || ThemeColorPalette.Neutral.neutralPrimary} !important`,
                            border: 'none !important',
                            [HighContrastSelector]: {
                                outlineColor: 'highlight !important'
                            }
                        },
                        [`.${IsFocusVisibleClassName} &:focus`]: {
                            backgroundColor: 'inherit',
                            [HighContrastSelector]: {
                                color: HighContrastColors.SelectedText,
                                backgroundColor: HighContrastColors.SelectedBackground,
                                fill: HighContrastColors.SelectedText,
                                i: {
                                    color: HighContrastColors.SelectedText
                                }
                            }
                        },
                        [`.${IsFocusVisibleClassName} &:focus:hover`]: {
                            backgroundColor: customTokens?.pickerBackgroundHover || theme?.palette.neutralLighter || ThemeColorPalette.Neutral.neutralLighter,
                            i: {
                                [HighContrastSelector]: {
                                    color: HighContrastColors.SelectedText
                                }
                            },
                            [HighContrastSelector]: {
                                color: HighContrastColors.SelectedText,
                                backgroundColor: HighContrastColors.SelectedBackground,
                                fill: HighContrastColors.SelectedText
                            }
                        }
                    }
                },
                callout: {
                    root: {
                        borderRadius: defaultBorderRadius
                    },
                    calloutMain: {
                        borderRadius: defaultBorderRadius
                    }
                }
            }
        },
        contextualMenuItemWrapper: {
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '4px'
        },
        contextualMenuItemIconWrapper: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            minWidth: '20px',
            color: customTokens?.pickerIcon || theme?.palette.neutralSecondary || ThemeColorPalette.Neutral.neutralSecondary,
            [HighContrastSelector]: {
                color: HighContrastColors.ButtonText
            }
        },
        contextualMenuItemLabelWrapper: {
            width: '148px',
            display: 'flex',
            justifyContent: 'space-between'
        },
        contextualMenuItemLabel: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: 'inherit',
            backgroundColor: 'inherit',
            fontFamily: `var(${ThemeFontsCssPropertyName.FontFamilyMenu}, inherit)`
        }
    };
}
/***
 * Helper function for retrieving the default tooltip style
 */ function getSensitivityTooltipDefaultStyle(theme) {
    return {
        tooltipCallout: {
            root: {
                backgroundColor: theme?.palette.white ?? ThemeColorPalette.Neutral.white,
                [HighContrastSelector]: {
                    backgroundColor: HighContrastColors.SelectedBackground
                }
            }
        },
        tooltipWrapper: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth: '210px'
        },
        tooltipTitle: {
            color: theme?.palette.neutralPrimary ?? ThemeColorPalette.Neutral.neutralPrimary,
            fontSize: `var(${ThemeFontsCssPropertyName.FontSizeHeading3}, inherit)`,
            fontFamily: `var(${ThemeFontsCssPropertyName.FontFamilyHeading3}, inherit)`,
            fontWeight: `var(${ThemeFontsCssPropertyName.FontWeightHeading3}, 600)`
        },
        tooltipBodyText: {
            color: theme?.palette.neutralPrimary ?? ThemeColorPalette.Neutral.neutralPrimary,
            fontSize: `var(${ThemeFontsCssPropertyName.FontSizeBody}, inherit)`,
            fontFamily: `var(${ThemeFontsCssPropertyName.FontFamilyBody}, inherit)`
        }
    };
}
/***
 * Helper function for retrieving the default justification dialog style
 */ function getSensitivityJustificationDefaultStyle(theme, customTokens) {
    return {
        modal: {
            main: {
                fontFamily: `var(${ThemeFontsCssPropertyName.FontFamilyBody}, inherit)`,
                fontSize: `var(${ThemeFontsCssPropertyName.FontSizeBody}, inherit)`,
                maxWidth: '384px',
                backgroundColor: customTokens?.dialogBackground || theme?.palette.white || ThemeColorPalette.Neutral.white,
                selectors: {
                    '@media (min-width: 480px)': {
                        maxWidth: '384px'
                    },
                    '.ms-Dialog-title': {
                        color: customTokens?.dialogHeadForeground || theme?.palette.neutralPrimary || ThemeColorPalette.Neutral.neutralPrimary,
                        fontFamily: `var(${ThemeFontsCssPropertyName.FontFamilyHeading1}, inherit)`,
                        fontSize: customTokens?.dialogHeadForegroundFontSize || `var(${ThemeFontsCssPropertyName.FontSizeHeading1}, 20px)`
                    },
                    '.ms-Dialog-subText': {
                        color: customTokens?.dialogBodForeground || theme?.palette.neutralPrimaryAlt || ThemeColorPalette.Neutral.neutralPrimaryAlt,
                        fontFamily: `var(${ThemeFontsCssPropertyName.FontFamilyBody}, inherit)`,
                        fontSize: customTokens?.dialogBodForegroundFontSize || `var(${ThemeFontsCssPropertyName.FontSizeBody}, inherit)`
                    },
                    '.ms-Dialog-button--close': {
                        display: 'none'
                    }
                }
            }
        },
        choiceGroup: {
            root: {
                selectors: {
                    '.ms-ChoiceField-field': {
                        selectors: {
                            '::before': {
                                backgroundColor: customTokens?.dialogBackground || theme?.palette.white || ThemeColorPalette.Neutral.white,
                                borderColor: customTokens?.dialogHeadForeground || theme?.palette.neutralPrimary || ThemeColorPalette.Neutral.neutralPrimary,
                                selectors: {
                                    [HighContrastSelector]: {
                                        backgroundColor: 'window'
                                    }
                                }
                            },
                            ':hover': {
                                selectors: {
                                    '::before': {
                                        borderColor: customTokens?.dialogBodRadioHover || theme?.palette.neutralPrimaryAlt || ThemeColorPalette.Neutral.neutralPrimaryAlt,
                                        selectors: {
                                            [HighContrastSelector]: {
                                                borderColor: 'windowText'
                                            }
                                        }
                                    },
                                    '::after': {
                                        backgroundColor: customTokens?.dialogBodRadioHover || theme?.palette.neutralPrimaryAlt || ThemeColorPalette.Neutral.neutralPrimaryAlt,
                                        selectors: {
                                            [HighContrastSelector]: {
                                                backgroundColor: 'windowText'
                                            }
                                        }
                                    }
                                }
                            },
                            ':active': {
                                selectors: {
                                    '::before': {
                                        borderColor: customTokens?.dialogBodRadioSelected || theme?.palette.themePrimary || ThemeColorPalette.Theme.themePrimary,
                                        selectors: {
                                            [HighContrastSelector]: {
                                                borderColor: 'highlight'
                                            }
                                        }
                                    },
                                    '::after': {
                                        backgroundColor: customTokens?.dialogBodRadioSelected || theme?.palette.themePrimary || ThemeColorPalette.Theme.themePrimary,
                                        selectors: {
                                            [HighContrastSelector]: {
                                                backgroundColor: 'highlight'
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    '.is-checked': {
                        selectors: {
                            '::before': {
                                borderColor: customTokens?.dialogBodRadioSelected || theme?.palette.themePrimary || ThemeColorPalette.Theme.themePrimary,
                                selectors: {
                                    [HighContrastSelector]: {
                                        borderColor: 'highlight'
                                    }
                                }
                            },
                            '::after': {
                                borderColor: customTokens?.dialogBodRadioSelected || theme?.palette.themePrimary || ThemeColorPalette.Theme.themePrimary,
                                selectors: {
                                    [HighContrastSelector]: {
                                        borderColor: 'highlight'
                                    }
                                }
                            },
                            ':hover': {
                                selectors: {
                                    '::before': {
                                        borderColor: customTokens?.dialogBodRadioSelected || theme?.palette.themePrimary || ThemeColorPalette.Theme.themePrimary,
                                        selectors: {
                                            [HighContrastSelector]: {
                                                borderColor: 'windowText'
                                            }
                                        }
                                    },
                                    '::after': {
                                        borderColor: customTokens?.dialogBodRadioSelected || theme?.palette.themePrimary || ThemeColorPalette.Theme.themePrimary,
                                        selectors: {
                                            [HighContrastSelector]: {
                                                borderColor: 'windowText'
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    '.ms-ChoiceFieldLabel': {
                        color: `${customTokens?.dialogBodForeground || theme?.palette.neutralPrimaryAlt || ThemeColorPalette.Neutral.neutralPrimaryAlt} !important`,
                        fontFamily: `var(${ThemeFontsCssPropertyName.FontFamilyBody}, inherit)`,
                        fontSize: customTokens?.dialogBodForegroundFontSize || `var(${ThemeFontsCssPropertyName.FontSizeBody}, inherit)`
                    }
                }
            }
        },
        textField: {
            root: {
                paddingTop: '8px'
            },
            fieldGroup: {
                backgroundColor: customTokens?.dialogBackground || theme?.palette.white || ThemeColorPalette.Neutral.white,
                borderColor: customTokens?.dialogBodForeground || theme?.palette.neutralPrimaryAlt || ThemeColorPalette.Neutral.neutralPrimaryAlt,
                selectors: {
                    ':hover': {
                        borderColor: customTokens?.dialogBodForeground || theme?.palette.neutralPrimaryAlt || ThemeColorPalette.Neutral.neutralPrimaryAlt
                    },
                    '::after': {
                        borderColor: customTokens?.dialogBodRadioSelected || theme?.palette.themePrimary || ThemeColorPalette.Theme.themePrimary,
                        selectors: {
                            [HighContrastSelector]: {
                                borderColor: 'highlight'
                            }
                        }
                    },
                    [HighContrastSelector]: {
                        selectors: {
                            ':hover': {
                                borderColor: 'highlight'
                            }
                        }
                    }
                }
            },
            field: {
                color: customTokens?.dialogBodForeground || theme?.palette.neutralPrimaryAlt || ThemeColorPalette.Neutral.neutralPrimaryAlt,
                fontFamily: `var(${ThemeFontsCssPropertyName.FontFamilyBody}, inherit) !important`,
                fontSize: `var(${ThemeFontsCssPropertyName.FontSizeBody}, inherit)`,
                selectors: {
                    '::placeholder': {
                        color: customTokens?.dialogBodForegroundDisabled || theme?.palette.neutralSecondary || ThemeColorPalette.Neutral.neutralSecondary
                    },
                    ':disabled': {
                        backgroundColor: customTokens?.dialogBackground || theme?.palette.white || ThemeColorPalette.Neutral.white,
                        color: customTokens?.dialogBodForegroundDisabled || theme?.palette.neutralSecondary || ThemeColorPalette.Neutral.neutralSecondary,
                        opacity: 1,
                        selectors: {
                            '::placeholder': {
                                color: customTokens?.dialogBodForegroundDisabled || theme?.palette.neutralSecondary || ThemeColorPalette.Neutral.neutralSecondary
                            }
                        }
                    },
                    [HighContrastSelector]: {
                        selectors: {
                            ':disabled': {
                                backgroundColor: 'window',
                                color: 'grayText',
                                selectors: {
                                    '::placeHolder': {
                                        color: 'grayText'
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        buttonWrapper: {
            marginTop: '16px',
            textAlign: 'right'
        },
        primaryButton: {
            root: {
                marginRight: '8px',
                fontFamily: `var(${ThemeFontsCssPropertyName.FontFamilyButton}, inherit) !important`,
                fontSize: customTokens?.dialogPrimaryButtonForegroundFontSize || `var(${ThemeFontsCssPropertyName.FontSizeButton}, 14px)`,
                color: customTokens?.dialogPrimaryButtonForeground || theme?.palette.white || ThemeColorPalette.Neutral.white,
                backgroundColor: customTokens?.dialogPrimaryButtonBackground || theme?.palette.themePrimary || ThemeColorPalette.Theme.themePrimary,
                borderColor: customTokens?.dialogPrimaryButtonBackground || theme?.palette.themePrimary || ThemeColorPalette.Theme.themePrimary
            },
            rootHovered: {
                color: customTokens?.dialogPrimaryButtonForegroundHover || theme?.palette.white || ThemeColorPalette.Neutral.white,
                backgroundColor: customTokens?.dialogPrimaryButtonBackgroundHover || theme?.palette.themeDarkAlt || ThemeColorPalette.Theme.themeDarkAlt,
                borderColor: customTokens?.dialogPrimaryButtonBackgroundHover || theme?.palette.themeDarkAlt || ThemeColorPalette.Theme.themeDarkAlt
            },
            rootPressed: {
                color: customTokens?.dialogPrimaryButtonForegroundPressed || theme?.palette.white || ThemeColorPalette.Neutral.white,
                backgroundColor: customTokens?.dialogPrimaryButtonBackgroundPressed || theme?.palette.themeDark || ThemeColorPalette.Theme.themeDark,
                borderColor: customTokens?.dialogPrimaryButtonBackgroundPressed || theme?.palette.themeDark || ThemeColorPalette.Theme.themeDark
            },
            rootDisabled: {
                color: customTokens?.dialogPrimaryButtonForegroundDisabled || theme?.palette.neutralTertiary || ThemeColorPalette.Neutral.neutralTertiary,
                backgroundColor: customTokens?.dialogPrimaryButtonBackgroundDisabled || theme?.palette.neutralLighter || ThemeColorPalette.Neutral.neutralLighter,
                borderColor: customTokens?.dialogPrimaryButtonBackgroundDisabled || theme?.palette.neutralLighter || ThemeColorPalette.Neutral.neutralLighter,
                selectors: {
                    [HighContrastSelector]: {
                        color: 'window',
                        backgroundColor: 'grayText',
                        borderColor: 'grayText'
                    }
                }
            },
            rootFocused: {
                selectors: {
                    ':after': {
                        outlineColor: `${customTokens?.dialogPrimaryButtonForeground || theme?.palette.white || ThemeColorPalette.Neutral.white} !important`
                    },
                    [HighContrastSelector]: {
                        selectors: {
                            ':after': {
                                inset: '2px !important',
                                outlineColor: 'window !important'
                            }
                        }
                    }
                }
            }
        },
        defaultButton: {
            root: {
                fontFamily: `var(${ThemeFontsCssPropertyName.FontFamilyButton}, inherit) !important`,
                fontSize: customTokens?.dialogDefaultButtonForegroundFontSize || `var(${ThemeFontsCssPropertyName.FontSizeButton}, 14px)`,
                color: customTokens?.dialogDefaultButtonForeground || theme?.palette.neutralPrimary || ThemeColorPalette.Neutral.neutralPrimary,
                backgroundColor: customTokens?.dialogDefaultButtonBackground || theme?.palette.white || ThemeColorPalette.Neutral.white,
                borderColor: customTokens?.dialogDefaultButtonForeground || theme?.palette.neutralPrimary || ThemeColorPalette.Neutral.neutralPrimary,
                selectors: {
                    [HighContrastSelector]: {
                        forcedColorAdjust: 'none',
                        color: 'windowText',
                        backgroundColor: 'window',
                        borderColor: 'windowText'
                    }
                }
            },
            rootHovered: {
                color: customTokens?.dialogDefaultButtonForegroundHover || theme?.palette.neutralPrimary || ThemeColorPalette.Neutral.neutralPrimary,
                backgroundColor: customTokens?.dialogDefaultButtonBackgroundHover || theme?.palette.neutralLighter || ThemeColorPalette.Neutral.neutralLighter,
                borderColor: customTokens?.dialogDefaultButtonForegroundHover || theme?.palette.neutralPrimary || ThemeColorPalette.Neutral.neutralPrimary,
                selectors: {
                    [HighContrastSelector]: {
                        color: 'highlightText',
                        backgroundColor: 'highlight',
                        borderColor: 'highlightText'
                    }
                }
            },
            rootPressed: {
                color: customTokens?.dialogDefaultButtonForegroundPressed || theme?.palette.neutralPrimary || ThemeColorPalette.Neutral.neutralPrimary,
                backgroundColor: customTokens?.dialogDefaultButtonBackgroundPressed || theme?.palette.neutralLight || ThemeColorPalette.Neutral.neutralLight,
                borderColor: customTokens?.dialogDefaultButtonForegroundPressed || theme?.palette.neutralPrimary || ThemeColorPalette.Neutral.neutralPrimary,
                selectors: {
                    [HighContrastSelector]: {
                        color: 'highlightText',
                        backgroundColor: 'highlight',
                        borderColor: 'highlightText'
                    }
                }
            },
            rootFocused: {
                selectors: {
                    ':after': {
                        outlineColor: `${customTokens?.dialogDefaultButtonForeground || theme?.palette.neutralPrimary || ThemeColorPalette.Neutral.neutralPrimary} !important`
                    },
                    [HighContrastSelector]: {
                        selectors: {
                            ':after': {
                                border: 'none !important',
                                inset: '2px !important',
                                outlineColor: 'windowText !important'
                            }
                        }
                    }
                }
            }
        },
        footerText: {
            fontSize: `var(${ThemeFontsCssPropertyName.FontSizeBody}, 10px)`,
            lineHeight: '12px',
            textAlign: 'start',
            marginTop: '10px',
            marginBottom: '0px',
            color: customTokens?.dialogFootForeground || theme?.palette.neutralSecondary || ThemeColorPalette.Neutral.neutralSecondary
        },
        footerLink: {
            fontSize: `var(${ThemeFontsCssPropertyName.FontSizeBody}, 10px)`,
            lineHeight: '12px',
            textDecoration: 'none',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            display: 'inline',
            margin: 0,
            padding: 0,
            color: customTokens?.dialogFootLink || theme?.palette.themePrimary || ThemeColorPalette.Theme.themePrimary,
            selectors: {
                i: {
                    height: '16px',
                    verticalAlign: 'middle'
                },
                svg: {
                    fontSize: '12px',
                    stroke: customTokens?.dialogFootLink || theme?.palette.themePrimary || ThemeColorPalette.Theme.themePrimary,
                    selectors: {
                        [HighContrastSelector]: {
                            stroke: 'linkText'
                        }
                    }
                },
                [HighContrastSelector]: {
                    color: 'linkText',
                    outlineColor: 'windowText'
                }
            }
        }
    };
}
const defaultSensitivityButtonBgColor = `var(${FluentV9ColorTokens.colorTransparentBackground}, 'transparent')`;
/***
 * Helper function for retrieving the default styling of Sensitivity Button control
 */ export function getSensitivityButtonDefaultStyle(props) {
    const { theme , customTokens , contextualMenuShown  } = props;
    const hoveredTextAndIconColor = customTokens?.clpButtonHover || `var(${FluentV9ColorTokens.colorNeutralForeground2BrandHover}, ${theme?.palette.themePrimary ?? ThemeColorPalette.Theme.themePrimary})`;
    const pressedTextAndIconColor = customTokens?.clpButtonPressed || `var(${FluentV9ColorTokens.colorNeutralForeground2BrandPressed}, ${theme?.palette.themeDarkAlt ?? ThemeColorPalette.Theme.themeDarkAlt})`;
    // If specified as `contextualMenuShown` from props, the color of the button should be as if it were hovered, regardless of true hover/focus state
    const restTextAndIconColor = contextualMenuShown ? hoveredTextAndIconColor : customTokens?.clpButton || `var(${FluentV9ColorTokens.colorNeutralForeground2}, ${theme?.palette.neutralSecondary ?? ThemeColorPalette.Neutral.neutralSecondary})`;
    return {
        wrapper: {
            display: 'flex',
            alignItems: 'center'
        },
        divider: {
            width: '0px',
            height: '20px',
            borderLeft: '1px solid',
            margin: '0px 4px',
            // ThemeColorPalette.Neutral.neutralQuaternary is #D2D0CE
            borderColor: customTokens?.floatieBorder || theme?.palette.neutralQuaternary || '#D1D1D1',
            selectors: {
                [HighContrastSelector]: {
                    borderColor: 'windowText'
                }
            }
        },
        button: {
            root: {
                padding: '4px',
                borderRadius: defaultButtonRadius,
                color: restTextAndIconColor,
                backgroundColor: customTokens?.clpButtonBackground || defaultSensitivityButtonBgColor,
                maxWidth: '132px',
                minWidth: '32px',
                height: '28px',
                fontSize: customTokens?.clpButtonFontSize || `var(${ThemeFontsCssPropertyName.FontSizeButton}, 12px)`,
                fontWeight: '400',
                fontFamily: `var(${ThemeFontsCssPropertyName.FontFamilyButton}, ${defaultFontFamily}) !important`,
                lineHeight: '16px',
                border: 'none',
                alignItems: 'center',
                display: 'inline-flex',
                fill: restTextAndIconColor,
                [HighContrastSelector]: {
                    forcedColorAdjust: 'none',
                    color: 'buttonText',
                    backgroundColor: 'buttonFace',
                    fill: 'buttonText'
                }
            },
            rootHovered: {
                color: hoveredTextAndIconColor,
                backgroundColor: customTokens?.clpButtonBackgroundHover || `var(${FluentV9ColorTokens.colorTransparentBackgroundHover}, 'transparent')`,
                fill: hoveredTextAndIconColor,
                selectors: {
                    [HighContrastSelector]: {
                        color: 'highlightText',
                        backgroundColor: 'highlight',
                        fill: 'highlightText'
                    }
                }
            },
            rootPressed: {
                color: pressedTextAndIconColor,
                backgroundColor: customTokens?.clpButtonBackgroundPressed || `var(${FluentV9ColorTokens.colorTransparentBackgroundPressed}, 'transparent')`,
                fill: pressedTextAndIconColor,
                selectors: {
                    [HighContrastSelector]: {
                        color: 'highlightText',
                        backgroundColor: 'highlight',
                        fill: 'highlightText'
                    }
                }
            },
            rootFocused: theme ? getFocusStyle(theme, {
                inset: 2,
                width: 2,
                borderRadius: 2
            }) : // eslint-disable-next-line import/no-deprecated, @typescript-eslint/consistent-type-assertions
            getFocusStyle({}, {
                inset: 2,
                width: 2,
                borderRadius: 2,
                borderColor: ThemeColorPalette.Neutral.white,
                outlineColor: ThemeColorPalette.Neutral.neutralSecondary
            }),
            rootDisabled: {
                color: customTokens?.clpButtonDisabled || theme?.palette.neutralTertiaryAlt || ThemeColorPalette.Neutral.neutralTertiaryAlt,
                backgroundColor: customTokens?.clpButtonBackgroundDisabled || 'transparent',
                fill: customTokens?.clpButtonDisabled || theme?.palette.neutralTertiaryAlt || ThemeColorPalette.Neutral.neutralTertiaryAlt,
                selectors: {
                    [HighContrastSelector]: {
                        color: 'grayText',
                        backgroundColor: 'buttonFace',
                        fill: 'grayText'
                    }
                }
            }
        },
        buttonText: {
            paddingInlineStart: '4px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '94px',
            selectors: {
                [HighContrastSelector]: {
                    forcedColorAdjust: 'none'
                }
            }
        },
        contextualMenu: getSensitivityContextualMenuDefaultStyle(theme, customTokens),
        tooltip: getSensitivityTooltipDefaultStyle(theme),
        justification: getSensitivityJustificationDefaultStyle(theme, customTokens)
    };
}
/***
 * Helper function for retrieving the spinner style
 */ export const sensitivitySpinnerStyle = {
    circle: {
        borderTopColor: ThemeColorPalette.Theme.themePrimary,
        borderBottomColor: ThemeColorPalette.Neutral.neutralLighter,
        borderLeftColor: ThemeColorPalette.Neutral.neutralLighter,
        borderRightColor: ThemeColorPalette.Neutral.neutralLighter
    }
};
